export const STEP_CONTAINER_CLASS =
  "px-4 sm:px-6 lg:px-8 py-12 min-h-[480px] sm:min-h-[520px] lg:min-h-[560px]";
export const CTA_ROW_CLASS = "flex flex-col sm:flex-row gap-3";
export const CTA_PRIMARY_COLUMN_CLASS = "flex-1 space-y-3";
export const CTA_SECONDARY_COLUMN_CLASS = "flex-1 sm:flex-none space-y-3 sm:min-w-[200px]";
export const CTA_PRIMARY_BUTTON_CLASS = "w-full";
export const CTA_SECONDARY_BUTTON_CLASS = "w-full";
